//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import debug from 'debug'
import { mapState } from 'vuex'
import SquareCanSvg from '@/assets/svg/square-can.svg?inline'
import waypointMixin from '@/mixins/waypoint'

// const log = debug('HomeHero')

export default {
  name: 'HomeHero',
  components: { SquareCanSvg },
  mixins: [waypointMixin],
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
}
